import { Messages } from '~src/codegen/Localize';


export enum IdentityMigrationFailureType {
  NON_EXISTENT = 'NON_EXISTENT',         // No matching results for this user in the related directory service.
  AMBIGUOUS = 'AMBIGUOUS',               // More than one matching record was found in the directory service for this system_user.
  DUPLICATE = 'DUPLICATE',               // The same backing identity is already associated with another system_user.
  NON_LOCAL_DOMAIN = 'NON_LOCAL_DOMAIN', // Local identity store is configured but the user is not part of the LOCAL domain.
  UNKNOWN = 'UNKNOWN',                   // An exception was raised while migrating the record.
}


export function localizeIdentityMigrationFailureType(failureType: keyof typeof IdentityMigrationFailureType): string {
  switch (failureType) {
    case IdentityMigrationFailureType.NON_EXISTENT:
      return Messages.identityMigration_FailureType_NonExistent();
    case IdentityMigrationFailureType.AMBIGUOUS:
      return Messages.identityMigration_FailureType_Ambiguous();
    case IdentityMigrationFailureType.DUPLICATE:
      return Messages.identityMigration_FailureType_Duplicate();
    case IdentityMigrationFailureType.NON_LOCAL_DOMAIN:
      return Messages.identityMigration_FailureType_NonLocal();
    case IdentityMigrationFailureType.UNKNOWN:
    default:
      return Messages.identityMigration_FailureType_Unknown();
  }
}

export function localizeIdentityMigrationFailureGroupHeader(failureType: keyof typeof IdentityMigrationFailureType): string {
  switch (failureType) {
    case IdentityMigrationFailureType.NON_EXISTENT:
      return Messages.identityMigration_FailureTypeGroup_NonExistent();
    case IdentityMigrationFailureType.AMBIGUOUS:
      return Messages.identityMigration_FailureTypeGroup_Ambiguous();
    case IdentityMigrationFailureType.DUPLICATE:
      return Messages.identityMigration_FailureTypeGroup_Duplicate();
    case IdentityMigrationFailureType.NON_LOCAL_DOMAIN:
      return Messages.identityMigration_FailureTypeGroup_NonLocal();
    case IdentityMigrationFailureType.UNKNOWN:
    default:
      return Messages.identityMigration_FailureTypeGroup_Unknown();
  }
}